import React from 'react';
import { Card } from 'components/ui/card';
import { cn, formatIndianNumber } from 'lib/utils';
import { VendorStats } from '../api';

export type VendorStatFilter = 'Total' | 'vehicle_owner' | 'broker';

interface VendorStatCardsProps {
    totalVendors?: number;
    stats?: VendorStats | null;
    activeStat?: VendorStatFilter;
    onStatCardClick?: (stat: VendorStatFilter) => void;
}

const VendorStatCards: React.FC<VendorStatCardsProps> = ({ totalVendors, stats, activeStat = 'Total', onStatCardClick }) => {
    if (!stats && totalVendors == null) return null;

    const totalActive = activeStat === 'Total';
    const vehicleOwnerActive = activeStat === 'vehicle_owner';
    const brokerActive = activeStat === 'broker';
    const vehicleOwnerCount = stats?.vehicle_owner_count ?? 0;
    const brokerCount = stats?.broker_count ?? 0;

    return (
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
            <Card
                variant="neutral"
                onClick={() => onStatCardClick?.('Total')}
                className={cn(
                    'p-3.5 select-none',
                    onStatCardClick && 'cursor-pointer transition-transform hover:scale-[1.01] active:scale-[0.99]',
                    totalActive && 'ring-2 ring-offset-2 ring-slate-400'
                )}
            >
                <div className="text-2xl font-bold tabular-nums text-slate-900">
                    {totalVendors ?? '-'} Vendors
                </div>
            </Card>

            <Card
                variant="total"
                onClick={() => onStatCardClick?.('vehicle_owner')}
                className={cn(
                    'p-3.5 select-none ring-1 ring-blue-300',
                    onStatCardClick && 'cursor-pointer transition-transform hover:scale-[1.01] active:scale-[0.99]',
                    vehicleOwnerActive && 'ring-2 ring-offset-2 ring-blue-500'
                )}
            >
                <div className="text-xl font-semibold tabular-nums text-slate-900">
                    {vehicleOwnerCount} Vehicle Owner{vehicleOwnerCount === 1 ? '' : 's'}
                </div>
                <div className="mt-2 text-sm text-slate-600">
                    Average Rate:{' '}
                    <span className="font-semibold tabular-nums text-slate-900">
                        ₹{formatIndianNumber(stats?.vehicle_owner_avg_rate)}
                    </span>
                </div>
            </Card>

            <Card
                variant="violet"
                onClick={() => onStatCardClick?.('broker')}
                className={cn(
                    'p-3.5 select-none',
                    onStatCardClick && 'cursor-pointer transition-transform hover:scale-[1.01] active:scale-[0.99]',
                    brokerActive && 'ring-2 ring-offset-2 ring-violet-400'
                )}
            >
                <div className="text-xl font-semibold tabular-nums text-slate-900">
                    {brokerCount} Broker{brokerCount === 1 ? '' : 's'}
                </div>
                <div className="mt-2 text-sm text-slate-600">
                    Average Rate:{' '}
                    <span className="font-semibold tabular-nums text-slate-900">
                        ₹{formatIndianNumber(stats?.broker_avg_rate)}
                    </span>
                </div>
            </Card>
        </div>
    );
};

export default VendorStatCards;
